import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authFetch } from '../../api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    const res = await authFetch('forget-password', {
      method: 'POST',
      body: JSON.stringify({ email })
    });

    if (res?.status === 'success') {
      setStatus({ type: 'success', message: 'Återställningslänk har skickats till din e-post.' });
    } else {
      setStatus({ type: 'error', message: res.error || 'Ett fel uppstod.' });
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-4 font-sans text-stone-900">
      <div className="max-w-md w-full bg-white p-8 border border-stone-200 shadow-sm">
        <div className="text-center mb-8">
          <Link to="/" className="inline-block mb-6">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/5c1e3a15fc68e7fca62dc4ec64936fd2c3f13f974599de31727b7a91865820cd8939af7242306cdc50be50497057948e/images/aW1hZ2UvcG5n/d6937394eb4d6a56959e8c727708d311.png" 
              alt="Logo" 
              className="h-10 w-auto mx-auto"
            />
          </Link>
          <h2 className="text-3xl font-serif mb-2">Återställ lösenord</h2>
          <p className="text-stone-500 font-light text-sm">Ange din e-post för att få en länk</p>
        </div>
        
        {status.message && (
          <div className={`mb-4 p-3 text-sm ${status.type === 'error' ? 'bg-red-50 text-red-600' : 'bg-green-50 text-green-600'}`}>
            {status.message}
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-widest text-stone-500 mb-2">E-post</label>
            <input 
              type="email" 
              required
              className="w-full px-4 py-3 border border-stone-200 focus:border-stone-900 focus:outline-none transition-colors"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button 
            type="submit" 
            disabled={loading}
            className="w-full py-4 bg-stone-900 text-white text-xs uppercase tracking-widest hover:bg-stone-800 transition-colors disabled:opacity-50 mt-4"
          >
            {loading ? 'Skickar...' : 'Skicka länk'}
          </button>
        </form>
        
        <div className="mt-8 text-center text-sm text-stone-500 font-light">
          <Link to="/login" className="text-stone-900 font-medium hover:underline">Tillbaka till inloggning</Link>
        </div>
      </div>
    </div>
  );
}